module.exports = __webpack_public_path__ + "img/img_004.3af507cc.png";